module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy-button"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.remove,
      "confirm": true
    }
  }, [_vm._v("Delete")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-090511ec!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/UserButtons.vue
// module id = 2248
// module chunks = 1